// extracted by mini-css-extract-plugin
export var container = "_4n-0";
export var disabled = "_4n-4";
export var fullWidth = "_4n-3";
export var lined = "_4n-1";
export var selected = "_4n-5";
export var tab = "_4n-2";